module.exports = __webpack_public_path__ + "static/media/DEENCONNECT_HHC_Logo.561a2395.png";